import {Component, OnInit} from '@angular/core';
import {LangService} from "../../services/lang.service";
import {UtilityService} from "../../services/utility.service";
@Component({
    selector: 'app-block-chat',
    templateUrl: './block-chat.component.html',
    styleUrls: ['./block-chat.component.scss'],
    standalone: false
})
export class BlockChatComponent implements OnInit {
    constructor(
        public lang: LangService,
        public utilityService: UtilityService,
    ) {
    }
    ngOnInit() {
    }
    openLiveChat() {
        this.utilityService.openExternalLink(
            'https://livechat.victimsupport.org.uk/newchat/chat.aspx?domain=www.mysupportspace.org.uk'
        )
    }
}
